export const LoginURLs = {
    loginView: '/login',
    verifyEmailView: '/verifyEmail',
    magicLinksDecodeView: '/magicLinks/decode/:id',
}